(function() {
  function setActiveSwatch(swatch) {
    if (!swatch) return;

    var container = swatch.closest('[data-swatches-container]');
    if (!container) return;

    container.querySelectorAll('[data-swatch]').forEach(function(node) {
      node.classList.toggle('is-selected', node === swatch);
    });
  }

  document.addEventListener(
    'mouseover',
    function(event) {
      var swatch = event.target.closest('[data-swatch]');
      if (swatch) setActiveSwatch(swatch);
    },
    true
  );

  document.addEventListener(
    'click',
    function(event) {
      var swatch = event.target.closest('[data-swatch]');
      if (!swatch) return;
      event.preventDefault();
      setActiveSwatch(swatch);
    },
    true
  );
})();
